module.exports = __webpack_public_path__ + "media/images/mailer/email-48-primary-2e1a4480c42a2540c0576e5572f28253.png";